import React, { ReactNode } from "react";
import { createRoot, Root } from "react-dom/client";
import ChangeStatusProgressFooter from "../MainPage/NotWorkArea(Side&Head)/ChangeStatusProgress";
import ModalProgress from "./components/ModalProgress";
import { AxiosRequest, XMLrequest } from "../Url";
import {
  getDocInfo,
  getModalSectionID,
  getSectionByID,
  getStyleWindow,
  isEmptyObject,
  outPutShow,
  updateSection,
} from "../MainPage/Tools/Tools";
import * as mime from "react-native-mime-types";
import FormsMainFile from "../MainPage/Sections/ElementsSections/Forms/FormsMainFile";
import MessageBox from "../MainPage/Module/MessageBox";
import HandleTable from "./components/HandleTable";
import { Grid } from "@mui/material";
import SignDialog from "../MainPage/Module/Dialogs/SignDialog";
import DialogSetObjText from "../MainPage/Module/Dialogs/DialogSetObjText";
import DialogWithTextField from "../MainPage/Module/Dialogs/DialogWithTextField";
import { CheckWorkSpace } from "../Singin/SingIn";
import TextAreaWithButtons from "../MainPage/Module/Dialogs/Components/TextAreaWithButtons";
import { buttonColors, smetaModals } from "../MainPage/Tools/modalManager";
import DialogParams from "../MainPage/Module/Dialogs/DialogParams";
import { headFormAtom, pushNewSectionAtom, sectionListAtom, setSelectedSectionAtom, smetaStore } from "../../atoms";
import { Button as DlgButton, DlgRes, DlgType, Prefixes, TITLE_MESSAGE_MODAL_WINDOW } from "../MainPage/Tools/ProjectX";
import { ViewClass } from "../MainPage/Tools/Consts";
import { selectDocument } from "./components/SelectDocument";
import { priviewDocument } from "./components/PriviewDocument";
import { defaultHandleTable } from "./components/defaultHandleTable";
import { addressEditKladrObj } from "./components/AddressEditKladrObj";
import { exposeDocument } from "./components/ExposeDocument";
import { editDocumentField } from "./components/EditDocumentField";
import { showDataSet } from "./components/ShowDataSet";
import { SequenceGetParams } from "../MainPage/Tools/Requests";
import DialogDocNumbering from "../MainPage/Module/Dialogs/DialogDocNumbering";
import DialogSelectFromList from "../MainPage/Module/Dialogs/DialogSelectFromList";
import { AxiosRequestConfig } from "axios";
import smetaAxios from "../SmetaAxios";
import { selectObject } from "./components/selectObject";
import { SubdataProps } from "../Editor/EditorComponents/ModalButton";
import { getHeadForm } from "../MainPage/NotWorkArea(Side&Head)/Header/Header";
import SmetaButton from "../MainPage/Tools/SmetaButton/SmetaButton";

const documentModal = [ViewClass.DocSite, ViewClass.DocBook];

const raiseTokenError = async ({ message = "Ошибка токена", reqId, subData }) => {
  console.error(message);
  await resumeRequest(reqId, subData, {
    Error: "1",
    $content: message,
  });
};

export function CheckModalBackGrounds(backgroundEl?: HTMLDivElement) {
  const allElements = [
    ...Array.from(document.querySelectorAll<HTMLDivElement>(".background_ModalDialog")),
    ...Array.from(document.querySelectorAll<HTMLDivElement>(".MuiDialog-root")),
  ];
  let count = 0;
  let maxZIndex = 0;
  for (const element of allElements) {
    if (!element || element === backgroundEl) continue;
    if (element.id && element.id.includes("loadmask")) continue;
    const computedStyle = window.getComputedStyle(element);
    if (
      element.matches(".MuiDialog-root") &&
      (computedStyle.visibility === "hidden" || computedStyle.display === "none")
    ) {
      continue;
    }
    count++;
    const zIndex = Number(computedStyle.zIndex);
    if (!isNaN(zIndex)) maxZIndex = Math.max(maxZIndex, zIndex);
  }
  return maxZIndex > 999 ? maxZIndex - 999 : count;
}

export function RemoveAllBG() {
  const backgroundElements = Array.from(document.querySelectorAll<HTMLDivElement>(".background_ModalDialog"));
  if (backgroundElements && backgroundElements.length > 0) {
    for (const element of backgroundElements) {
      element.remove();
    }
  }
}

export function CreateBackgroundForModal(elem: ReactNode, id?: string, zIndex?: number) {
  const background3 = document.createElement("div");
  background3.classList.add("background_ModalDialog");
  background3.style.height = "100%";
  background3.id = id === undefined ? "" : id;
  background3.style.width = "100%";
  background3.style.position = "absolute";
  background3.style.top = "0px";
  background3.style.background = "";
  // background3.style.backdropFilter = "blur(2px)";

  if (id && id.includes("loadmask")) background3.style.backdropFilter = "";
  background3.style.zIndex = `${
    zIndex === undefined ? 1000 + CheckModalBackGrounds() : zIndex + CheckModalBackGrounds()
  }`;
  if (elem) createRoot(background3).render(elem);
  document.body.appendChild(background3);
  return background3;
}

export function renderMessageBox(paramMessageBox: {
  dlgType: DlgType;
  buttons?: string | number;
  message: string;
  closeF?: any;
  selectF?: (
    ev: React.MouseEvent<HTMLButtonElement>,
    requestId?: number | string,
    setReturnValue?: any,
    from?: any,
  ) => Promise<void> | void;
  func?: any;
  from?: any;
  idModal?: string;
}) {
  // 0 - Предупреждение, 1- Ошибка, 2 - Информация, 3 = Подтверждение,
  smetaModals.open(
    <MessageBox
      DlgType={paramMessageBox.dlgType}
      Message={paramMessageBox.message}
      Buttons={paramMessageBox.buttons}
      onSelect={paramMessageBox.selectF}
      setReturnValue={paramMessageBox.func}
      from={paramMessageBox.from}
    />,
    {
      id: paramMessageBox.idModal,
      style: getStyleWindow("MessageBox"),
      hiddenButton: true,
      blockMaximize: true,
      blockSaveLocation: true,
      blockResize: true,
      Title: TITLE_MESSAGE_MODAL_WINDOW[paramMessageBox.dlgType],
      onClose: () => {
        paramMessageBox.closeF?.({ target: { value: "2" } }, undefined, paramMessageBox.func, paramMessageBox.from);
      },
    },
  );
}

var funcGlobal;

export function buildFileSelector(info) {
  return new Promise((resolve) => {
    const fileSelector = document.createElement("input");
    fileSelector.setAttribute("type", "file");
    fileSelector.setAttribute("accept", info?.filter || "file");
    fileSelector.setAttribute("multiple", info?.multiple);
    fileSelector.addEventListener("change", async (e) => {
      const files = Array.from(e.target.files); //сохраняем коллекцию файлов
      // const params = new Map();
      // params.set("prefix", "project");
      // params.set("comand", "ResumeRequest");
      // params.set("RequestID", requestID);
      // params.set("WSM", "1");
      const filesNames = files.map((file) => file.name).join("\n"); //сюда достаем имена файлов, что бы потом через join получить имена
      const filesData = await Promise.all(files.map((file) => getBase64ByFileReader(file)));
      const finalData = filesData.reduce(
        (acc, fileData, index) => ({
          ...acc,
          [files[index].name]: {
            size: files[index].size,
            rcdata: fileData.rcdata,
            name: files[index].name,
          },
        }),
        {},
      );
      // ОТПРАВКА ОДНОГО ФАЙЛА НА СЕРВЕР
      // const firstRcData = Object.keys(filesData)?.length > 1 ? "" : finalData[filesNames]?.rcdata;
      // resolve({
      //   reqData: { FileName: filesNames, Result: "1", $content: filesNames, rcdata: firstRcData },
      //   files: finalData,
      // });
      resolve({ reqData: { FileName: filesNames, Result: "1", $content: filesNames }, files: finalData });
      // const json = await AxiosRequest(true, params, { FileName: filesNames, Result: "1", $content: filesNames });
      // tokenProcessingTest(json, { ...subData, props: { ...subData.props, files: finalData } });
    });
    fileSelector.addEventListener("cancel", () => {
      resolve();
      // resumeRequest(requestID, subData);
    });
    fileSelector.click();
  });
}

export const getBase64ByFileReader = (file) => {
  const reader = new FileReader();
  return new Promise((resolve) => {
    reader.onload = (ev) => {
      const fileArr = ev.target.result.split(","); //нам нужна только часть с base64, без mime информации
      const [fileType, file] = fileArr;
      // const [fileType] = fileT.match(/(^data:){0}[a-z/]+(?=;)/);
      resolve({ fileType, rcdata: file });
    };
    reader.readAsDataURL(file);
  });
};

function InputTextChange(Text, RequestID, event, func) {
  let params = new Map(),
    data,
    json;
  //const data1 = new FormData(event.currentTarget);

  if (event === false) {
    data = { Result: "" };
  } else {
    data = { Text: Text, Result: 1 };
  }
  params.set("prefix", "project");
  params.set("comand", "ResumeRequest");
  params.set("RequestID", RequestID);
  params.set("WSM", "1");
  json = XMLrequest(params, data);
  tokenProcessingTest(json, { func: func });
}

const getSerialInfo = (serial: string) => {
  return window.webkcrypt.x509_load_by_serial(serial).value;
};

export function executeCertList() {
  return window.webkcrypt.plain_text_certificate_list().value;
}

function executeDetachedTest(sn, data) {
  return window.webkcrypt.make_pkcs7_signature(sn, data, true).value;
}

function handleMessageList(response, subData, RequestID) {
  if (response !== "") {
    sendCertListWSM(response, subData, RequestID);
  } else {
    sendCertListWSM(undefined, subData, RequestID);
  }
}

function sendCertListWSM(res, subData, RequestID) {
  let params = new Map(),
    data,
    json;
  data = { res: res ? res : "" };
  params.set("prefix", "project");
  params.set("comand", "ResumeRequest");
  params.set("RequestID", RequestID);
  params.set("WSM", "1");
  json = XMLrequest(params, data);
  tokenProcessingTest(json, subData);
}

function handleMessageSign(message, RequestID, subData) {
  let params = new Map();
  params.set("prefix", "project");
  params.set("comand", "ResumeRequest");
  params.set("RequestID", RequestID);
  params.set("WSM", "1");
  // const json = XMLrequest(params, {"RCDATA":response.result});
  // tokenProcessingTest(json, funcGlobal);
  let rcdata = message;
  // if (typeof response.result === "string") {
  //   rcdata = response.result;
  // } else if (typeof response.result.result === "string") {
  //   rcdata = response.result.result;
  // }
  AxiosRequest(true, params, { RCDATA: rcdata }).then((res) => {
    tokenProcessingTest(res, subData);
  });
}

export function sendRequest(request, handler) {
  window.postMessage(request, handler === undefined ? "*" : handler);
}

export function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

class WebkcryptCallback {
  constructor(uuid, callback) {
    this.callback = callback;
    this.uuid = uuid;
    this.handle = (event) => {
      var handled = false;
      try {
        if (event && event.data) {
          if ("type" in event.data && event.data.type == "webkcrypt-reply") {
            if ("uuid" in event.data && event.data.uuid == this.uuid) {
              handled = this.callback(event);
              if (handled) {
                window.removeEventListener("message", this.handle);
              }
            }
          }
        }
        return handled;
      } catch (error) {
        console.error(error);
      }
    };
  }
}

function webkcryptdata(method, args) {
  var data = {
    type: "webkcrypt-invoke",
    uuid: uuid(),
    invoke: {
      method: method,
    },
  };
  if (args) {
    data.invoke.args = args;
  }
  return data;
}

export function webkcrypt_invoke(method, args, callback) {
  var data = webkcryptdata(method, args);
  if (callback) {
    window.addEventListener("message", new WebkcryptCallback(data.uuid, callback).handle, false);
  }
  window.postMessage(data, "*");
}

export async function resumeRequest(RequestID, subData, datas) {
  let params = new Map(),
    data,
    json;
  data = { Result: datas ? datas : "" };
  params.set("prefix", "project");
  params.set("comand", "ResumeRequest");
  params.set("RequestID", RequestID);
  params.set("WSM", "1");
  json = await AxiosRequest(true, params, datas ? datas : data);
  tokenProcessingTest(json, subData);
}

export async function InputButton(event, RequestID, func, from, props) {
  let ClickedButton = event.currentTarget?.value ?? event.target.value,
    request;
  if (props && props.Button && props.Request) {
    ClickedButton = props.Button;
    request = props.Request;
  }
  let params = new Map(),
    data = { Result: ClickedButton },
    json;

  if (request) data = { Result: ClickedButton, [request.Name]: request.Value };
  if (request && request.subName) data[request.subName] = request.Value;

  params.set("prefix", "project");
  params.set("comand", "ResumeRequest");
  params.set("RequestID", RequestID);
  params.set("WSM", "1");
  json = await AxiosRequest(true, params, data);
  tokenProcessingTest(json, {
    func: func,
    propsId: RequestID,
    from: from,
    props: props,
  });
}

export function SetLoadingCursor(load, zIndex, remove) {
  if (load) {
    const Mask = document.getElementById("loadmask");
    if (Mask) {
      Mask.remove();
    } else if (!remove) {
      CreateBackgroundForModal(
        <div
          style={{
            cursor: "wait",
            width: "100%",
            height: "100%",
            userSelect: "none",
          }}
          loadmask=""
        ></div>,
        "loadmask",
      );
    }
  }
}

export function setLoadingCursorAxios(load) {
  if (load) {
    const elem = CreateBackgroundForModal(null, "loadmask" + CheckModalBackGrounds());
    elem.style.cursor = "wait";
    elem.style.width = "100%";
    elem.style.height = "100%";
    return elem;
  }
}

export const GetDialogParam = (ObjType, module, ObjRef, RequestID, OnlyView?: any, MultiSel?: any) => {
  let param = new Map(),
    json;
  param.set("prefix", module);
  param.set("comand", "GetDialogParams");
  param.set("ObjType", ObjType);
  param.set("ObjRef", ObjRef ? ObjRef : "0");
  if (OnlyView !== undefined) param.set("OnlyView", OnlyView);
  if (MultiSel) param.set("MultiSel", MultiSel);

  json = XMLrequest(param);
  return json;
};

export function GetParams(json, param) {
  return json[param] === undefined ? json[param.toLowerCase()] : json[param];
}

function changeTextInModalButton(json: Record<string, string>) {
  const objWithNewText: Record<string, string> = {};
  for (const [key, value] of Object.entries(json)) {
    if (key.includes("Кнопка")) {
      Object.assign(objWithNewText, { [key.split("$")[1]]: value });
    }
  }
  return objWithNewText;
}

export function getButtons(json) {
  let buttonFlags: number, buttonsJson: Record<string, string>, disabledButtons, hiddenButtons: Record<number, boolean>;
  if (typeof json === "number") {
    buttonFlags = json;
    buttonsJson = {};
    disabledButtons = {};
    hiddenButtons = {};
  } else {
    buttonFlags = json?.Params?.Buttons || json?.Buttons;
    buttonsJson = changeTextInModalButton(json?.jsonData || {});
    disabledButtons = json?.disabledButtons || {};
    hiddenButtons = json?.hiddenButtons || {};
  }
  if (!buttonFlags) buttonFlags = DlgButton.Ok;
  const buttonsArr: ReactNode[] = [];
  const buttonConfig = [
    {
      condition: DlgButton.Ok,
      label: "ОК",
      value: DlgRes.Ok,
      defaultText: buttonsJson["Выбрать"]
        ? buttonsJson["Выбрать"]
        : json.Token === "ExecuteModalDialog"
          ? "Выбрать"
          : "ОК",
    },
    { condition: DlgButton.Yes, label: "Да", value: DlgRes.Yes },
    { condition: DlgButton.No, label: "Нет", value: DlgRes.No },
    { condition: DlgButton.Abort, label: "Прервать", value: DlgRes.Abort },
    { condition: DlgButton.Retry, label: "Повторить", value: DlgRes.Retry },
    { condition: DlgButton.Ignore, label: "Пропустить", value: DlgRes.Ignore },
    { condition: DlgButton.All, label: "Для всех", value: DlgRes.All },
    { condition: DlgButton.NoToAll, label: "Нет для всех", value: DlgRes.NoToAll },
    { condition: DlgButton.YesToAll, label: "Да для всех", value: DlgRes.YesToAll },
    { condition: DlgButton.Cancel, label: "Отмена", value: DlgRes.Cancel, className: "button_Modal_Close" },
  ];
  buttonConfig.forEach(({ condition, label, value, defaultText, className = "button_Modal_Select" }) => {
    if (!hiddenButtons[condition] && buttonFlags & condition)
      buttonsArr.push(
        <Grid key={`modal-btn_${condition}`}>
          <SmetaButton
            size="small"
            style={{ textTransform: "none", marginLeft: 10 }}
            variant="outlined"
            color={buttonColors[condition] ?? "info"}
            className={className}
            value={value}
            disabled={disabledButtons[condition]}
          >
            {buttonsJson[label] || defaultText || label}
          </SmetaButton>
        </Grid>,
      );
  });
  return buttonsArr;
}

const activateRange = async (json, subData) => {
  const grids = Array.from(document.querySelectorAll("[salary_grid]"));
  if (grids.length > 0) {
    const activateRangeGrids = grids.filter((val) => val.grid && val.grid.activateRange);
    for (const grid of activateRangeGrids) {
      grid.grid.activateRange({ year: json.Params.Year, month: json.Params.Month, range: json.Params.Range });
    }
  }
  await resumeRequest(json.RequestID, subData);
};

const refreshAmounts = async (reqId, subData) => {
  const grids = Array.from(document.querySelectorAll("[salary_grid]"));
  if (grids.length > 0) {
    await Promise.all(
      grids.map((grid) => grid.grid && grid.grid.refreshSource(grid.grid.source.getKeyFieldNameData())),
    );
  }
  const individualGrid = grids.filter((grid) => grid.grid && grid.grid.resetValues);
  if (individualGrid.length > 0) await individualGrid[0].grid.resetValues();

  await resumeRequest(reqId, subData);
};

const scrollToDocument = async (json, subData) => {
  if (!json || !json.Params) return resumeRequest(json.Params.RequestID, subData);

  const sectionsData = await getDocInfo(json.Params.DocID);
  const sections = sectionsData.Sections.split(",");
  if (!sections.length) return resumeRequest(json.Params.RequestID, subData);

  const sideBarSlice = getSectionByID(sections[0]);
  const result = {
    ...sideBarSlice,
    Who: "doc",
    Selected: { DocCfgID: json.Params.DocCfgID, docid: json.Params.DocID },
  };
  smetaStore.set(setSelectedSectionAtom, result);

  return resumeRequest(json.Params.RequestID, subData);
};

const selectFile = async (json, subData, requestID) => {
  let fileFilter;
  fileFilter = json.Params.Filter;
  if (fileFilter) {
    fileFilter = fileFilter.match(/\.[a-z]+/g);
    fileFilter = fileFilter?.filter(function (item, pos) {
      return fileFilter.indexOf(item) == pos;
    });
    fileFilter?.join(",");
  }
  const resp = await buildFileSelector(
    { filter: fileFilter, multiple: Boolean(json.Params.MultiSel) },
    requestID,
    subData,
  );
  if (resp) {
    resumeRequest(json.Params.RequestID, { ...subData, props: { ...subData.props, files: resp.files } }, resp.reqData);
  } else resumeRequest(json.Params.RequestID, subData, { Error: "1" });
};

export const shellExecute = (json, subData = {}, requestID = "0") => {
  let RCDATA = "";
  let FileNameShell = json.Params.FileName;
  FileNameShell = FileNameShell.split("\\");
  if (json.RCDATA) {
    RCDATA = json.RCDATA;
  } else if (subData.RCDATA) {
    RCDATA = subData.RCDATA;
  } else {
    window.open(json.Params.FileName);
    resumeRequest(requestID, subData);
    return;
  }
  let mimeType = mime.lookup(FileNameShell.slice(-1)[0]) || "application/octet-stream";
  mimeType = "data:" + mimeType + ";base64,";
  if (showContent({ data: json, rcdata: RCDATA, mimeType, subData, fileName: FileNameShell })) {
    downloadFile(mimeType + RCDATA, json, subData);
  }
};

const refreshDocument = async (json, subData) => {
  const documentByDcfg = document.getElementById("gridpanel" + json.Params.DocCfgID);
  if (documentByDcfg) {
    await documentByDcfg.grid?.refreshDocumentToken?.(true);
  }
  return resumeRequest(json.Params.RequestID, subData);
};

const loadBySerialNumber = async (json, subData) => {
  const { failed, value } = await getSerialInfo(json.Params["СерийныйНомер"]);
  const data = failed === 1 ? { Error: "1" } : { RCDATA: value.x509.value, Result: "1" };
  return resumeRequest(json.Params.RequestID, subData, data);
};

const getFileStream = async (json, subData) => {
  const {
    Params: { RequestID: reqId, FileName: fileName },
  } = json;
  let RCDATAlocal = "";
  if ((selectedFile !== undefined && fileName === selectedFile.name) || (subData.props && subData.props.files)) {
    if (selectedFile && fileName === selectedFile.name) RCDATAlocal = selectedFile.RCDATA;
    if (subData.props && subData.props.files) {
      for (const [index, file] of Object.entries(subData.props.files)) {
        if (index === fileName) RCDATAlocal = file.rcdata;
      }
    }
    const requestConfig: AxiosRequestConfig = {
      params: {
        RequestID: reqId,
        WSM: 1,
      },
    };
    const data = { RCDATA: RCDATAlocal };
    const resp = await smetaAxios.post("resumeRequest", data, requestConfig);
    tokenProcessingTest(resp, subData);
  } else {
    const errMessage = "Файл не найден в памяти, либо файл в другой цепочке запросов";
    console.error(errMessage);
    resumeRequest(reqId, subData, {
      Error: "1",
      $content: errMessage,
    });
  }
};

const commitFormOnHead = (json, subData) => {
  const headFormData = getHeadForm("GetSectionHead");
  smetaStore.set(headFormAtom, headFormData);
  return resumeRequest(json.Params.RequestID, subData);
};

const clearFormOnHead = (json, subData) => {
  const headFormData = getHeadForm("ClearFormOnHead");
  smetaStore.set(headFormAtom, headFormData);
  return resumeRequest(json.Params.RequestID, subData);
};

var selectedFile;

type Tokens =
  | "RefreshAmounts"
  | "ActivateRange"
  | "SetClipboardText"
  | "GetClipboardText"
  | "MessageBox"
  | "HideProgressDialog"
  | "RefreshDocument"
  | "CommitFormOnSection"
  | "ClearFormOnSection"
  | "Navigate"
  | "ShowDataSet"
  | "ClientValidateStream"
  | "SignDialog"
  | "cryptox509_loadbyserialnumber"
  | "ClientSignStream"
  | "GetCertificateList"
  | "PutFileStream"
  | "ClearOutPut"
  | "OutPutText"
  | "GetDirectory"
  | "SelectListIndex"
  | "ShellExecute"
  | "EditDocumentField"
  | "ExposeDocument"
  | "ExecuteModalDialog"
  | "ExecuteParamDialog"
  | "FileExists"
  | "GetFileStream"
  | "AddressEditKladrObj"
  | "StepProgress"
  | "FindDuplicates"
  | "SelectSequence"
  | "HandleTable"
  | "SelectFromList"
  | "ScrollToDocument"
  | "PriviewDocument"
  | "SelectDocument"
  | "SelectObject"
  | "GetFileSize"
  | "SelectFolder"
  | "SelectFile"
  | "SetProgressLabel"
  | "ShowProgressDialog"
  | "InputText"
  | "EditText"
  | "ChangeStatusProgress"
  | "CommitFormOnHead"
  | "ClearFormOnHead";

export interface TokenJson {
  Token?: Tokens;
  Break?: "1";
  Params?: {
    RequestID: string;
  };
}

export interface TokenSubData {
  func?: (data: unknown) => void | Promise<void>;
  from?: "Forms" | "ModalProgress" | "grid";
  props?: SubdataProps;
  [key: string]: any;
}
export function tokenProcessingTest(json: TokenJson, subData: TokenSubData = {}) {
  //  func, subData.propsId, from, props
  if (json !== undefined && json.Break !== undefined) {
    const from = subData.from;
    const Token = json.Token;
    const RequestID = json.Params ? json.Params.RequestID : undefined;
    window.removeEventListener("message", handleMessageList);
    window.removeEventListener("message", handleMessageSign);

    switch (Token) {
      case "RefreshAmounts": {
        refreshAmounts(RequestID, subData);
        break;
      }
      case "ActivateRange": {
        activateRange(json, subData);
        break;
      }
      case "SetClipboardText": {
        try {
          navigator.clipboard.writeText(json.Params.Text);
        } catch {
          alert(json.Params.Text);
        } finally {
          resumeRequest(RequestID, subData);
        }
        break;
      }
      case "GetClipboardText": {
        try {
          navigator.clipboard
            .readText()
            .then((clipText) => resumeRequest(RequestID, subData, { Result: clipText }))
            .catch(() => {
              resumeRequest(RequestID, subData);
            });
        } catch {
          resumeRequest(RequestID, subData);
        }
        break;
      }
      case "MessageBox":
        smetaModals.open(
          <MessageBox
            DlgType={json.Params.DlgType ? Number(json.Params.DlgType) : 0}
            from={from}
            Message={json.Params.Message}
            Buttons={json.Params.Buttons}
            RequestID={RequestID}
            onSelect={InputButton}
            setReturnValue={subData.func}
          />,
          {
            style: getStyleWindow("MessageBox"),
            hiddenButton: true,
            blockMaximize: true,
            blockSaveLocation: true,
            blockResize: true,
            Title: json.Params.DlgType
              ? TITLE_MESSAGE_MODAL_WINDOW[Number(json.Params.DlgType)]
              : TITLE_MESSAGE_MODAL_WINDOW[0],
            onClose: () => {
              InputButton({ target: { value: "2" } }, RequestID, subData.func, from);
            },
          },
        );
        break;

      case "HideProgressDialog":
        const progressDialog = document.getElementById("footerProgress");
        if (progressDialog && progressDialog.firstChild) progressDialog.firstChild.remove();
        const ProgressDialogRef = document.getElementById("ProgressDialog" + RequestID);
        if (ProgressDialogRef && ProgressDialogRef.hideDialog) {
          ProgressDialogRef.hideDialog();
        }
        resumeRequest(RequestID, subData);
        break;

      case "ChangeStatusProgress":
        const footerProgressEl = document.getElementById("footerProgress")!;
        const footerProgressElRoot: Root = footerProgressEl.root || createRoot(footerProgressEl);
        footerProgressEl.root = footerProgressElRoot;
        footerProgressElRoot.render(
          <ChangeStatusProgressFooter Json={json} setReturnValue={subData.func} from={from} subData={subData} />,
        );
        break;

      case "EditText":
        if (!json?.Params) break;
        smetaModals.open(
          <TextAreaWithButtons
            props={{
              Title: json.Params.Caption,
              Value: json.Params.Text,
              RequestID: RequestID,
              func: subData.func,
              onEdit: (data) => {
                const json = resumeRequest(RequestID, subData, {
                  Text: data.value,
                  Result: "1",
                });
                if (json.NeedRefresh) data.func(json, data);
              },
            }}
          />,
          {
            Title: json.Params.Caption,
            style: { minWidth: "400px" },
            onClose: () => {
              subData.props?.input?.current?.focus();
              resumeRequest(RequestID, subData, {});
            },
            hiddenButton: true,
          },
        );
        break;

      case "InputText":
        let inputTextEditor;
        const isMultiline = json?.Params?.MultiLines === "1";
        if (isMultiline) {
          inputTextEditor = (
            <TextAreaWithButtons
              props={{
                Title: json.Params.Title,
                Value: json.Params.Text,
                maxLength: json.Params.Length,
                RequestID: RequestID,
                from: from,
                func: subData.func,
                onEdit: (data) => {
                  const json = resumeRequest(RequestID, subData, {
                    Text: data.value,
                    Result: "1",
                  });
                  if (json.NeedRefresh) data.func(json, data);
                },
              }}
            />
          );
        } else {
          inputTextEditor = (
            <DialogWithTextField
              props={{
                func: subData.func,
                from: from,
                Title: json.Params?.Title,
                Value: json.Params?.Text,
                onSelect: (data) => {
                  const json = resumeRequest(RequestID, subData, {
                    Text: data.value,
                    Result: "1",
                  });
                  if (json.NeedRefresh) data.func(json, data);
                },
              }}
            />
          );
        }
        smetaModals.open(inputTextEditor, {
          Title: json.Params?.Caption,
          style: getStyleWindow(isMultiline ? "EnterText" : "InputText"),
          blockMaximize: !isMultiline,
          blockSaveLocation: true,
          blockResize: !isMultiline,
          onClose: () => {
            subData.props?.input?.current?.focus();
            resumeRequest(RequestID, subData, {});
          },
          hiddenButton: isMultiline,
        });
        break;

      case "ShowProgressDialog":
        const Path = json.Params.Path;
        // todo ReactDOM.unmountComponentAtNode
        const doc = document.getElementById("RenderModal")!;
        const docRoot: Root = doc.root || createRoot(doc);
        doc.root = docRoot;
        //todo Выбивает предупреждение о необходимости root.unmount(), хотя нет дочерних элементов из-за особенности MUI Dialog
        docRoot.render(<ModalProgress open={true} Json={json} path={Path} setReturnValue={subData.func} from={from} />);
        break;

      case "SetProgressLabel":
        if (subData.from === "ModalProgress") {
          subData.func?.(json);
        } else {
          resumeRequest(RequestID, subData);
        }
        break;

      case "SelectFile":
        selectFile(json, subData, RequestID);
        break;

      case "SelectFolder":
        resumeRequest(RequestID, subData, { Result: "1", Path: "" });
        break;

      case "GetFileSize":
        let size = subData.size;
        if (subData.props && subData.props.files) {
          for (const file of Object.values(subData.props.files)) {
            if (file.name === json.Params.FileName) size = file.size;
          }
        }
        InputButton({ target: { value: size } }, RequestID, subData.func, subData.from, subData.props);
        break;

      case "SelectObject":
        selectObject({ json, subData, requestID: RequestID });
        break;

      case "SelectDocument":
        selectDocument({ json, subData, requestID: RequestID });
        break;

      case "PriviewDocument":
        priviewDocument({ json, subData, requestID: RequestID });
        break;

      case "ScrollToDocument":
        scrollToDocument(json, subData);
        break;

      case "SelectFromList":
        if (!json.Params) break;
        smetaModals.open(
          <DialogSelectFromList
            props={{
              ...subData.props,
              sourName: json.Params.SourName,
              destName: json.Params.DestName,
              sourList: json.Params.SourList,
              destList: json.Params.DestList,
              RequestID: json.Params.RequestID,
              func: subData.func,
              from: from,
            }}
          />,
          {
            Title: json.Params.Title,
            style: getStyleWindow("SelectFromList"),
            onClose: () => {
              subData.props?.input?.current?.focus();
              resumeRequest(RequestID, subData, {});
            },
          },
        );
        break;

      case "HandleTable":
        defaultHandleTable({ json, subData, requestID: RequestID });
        break;

      case "SelectSequence":
        SequenceGetParams({
          Name: json?.Params?.Items,
          GetNumMode: "1",
        }).then((res) => {
          smetaModals.open(
            <DialogDocNumbering
              props={{
                Sequence: json?.Params?.Items,
                res: res,
              }}
            />,
            {
              Title: "Нумерация",
              style: getStyleWindow("sequence"),
              onClose: () => {
                subData.props?.input?.current?.focus();
                resumeRequest(RequestID, subData);
              },
            },
          );
        });
        break;

      case "FindDuplicates":
        resumeRequest(RequestID, subData);
        break;

      case "StepProgress":
        if (subData.from === "ModalProgress") {
          subData.func(json);
        } else {
          resumeRequest(RequestID, subData);
        }
        break;

      case "AddressEditKladrObj":
        addressEditKladrObj({ json, subData, requestID: RequestID });
        break;

      case "GetFileStream":
        let FileName = json.Params.FileName,
          data,
          RCDATAlocal = "",
          params = new Map();
        if ((selectedFile !== undefined && FileName === selectedFile.name) || (subData.props && subData.props.files)) {
          if (selectedFile && FileName === selectedFile.name) RCDATAlocal = selectedFile.RCDATA;
          if (subData.props && subData.props.files) {
            for (const [index, file] of Object.entries(subData.props.files)) {
              if (index === FileName) RCDATAlocal = file.rcdata;
            }
          }
          params.set("prefix", "project");
          params.set("comand", "ResumeRequest");
          params.set("RequestID", RequestID);
          params.set("WSM", "1");
          data = { RCDATA: RCDATAlocal };
          AxiosRequest(true, params, data)
            .then((res) => {
              tokenProcessingTest(res, subData);
            })
            .catch((reason) => {
              const {
                response: { status, statusText },
              } = reason;
              return raiseTokenError({
                message: `${status}: ${statusText}`,
                subData,
                reqId: RequestID,
              });
            });
        } else {
          const errMessage = "Файл не найден в памяти, либо файл в другой цепочке запросов";
          return raiseTokenError({
            message: errMessage,
            subData,
            reqId: RequestID,
          });
        }
        break;

      case "FileExists":
        resumeRequest(RequestID, subData, { Result: "1" });
        break;

      case "ExecuteParamDialog":
        SetLoadingCursor(true, undefined, true);
        let params1 = new Map(),
          json1;
        params1.set("prefix", "programs");
        params1.set("comand", "GetParamDialog");
        params1.set("GroupID", "0"); ///// ПРОВЕРИТЬ
        params1.set("Path", json.Params.Path);
        params1.set("NeedRefresh", "1");
        json1 = XMLrequest(params1);

        smetaModals.open(
          <DialogParams
            props={{
              Module: "programs",
              reqCommand: "GetParamDialog",
              GroupID: "0",
              Path: json.Params.Path,
              RequestID: json.Params.RequestID,
              setReturnValue: subData.func,
              from: from,
              func: subData.func,
              data: json1,
              NoTitle: !json1.Title,
              NoHistory: true,
              ExecEvent: json?.Params?.ExecEvent,
              onClose: () => resumeRequest(RequestID, subData, {}),
            }}
          />,
          {
            Title: json1.Caption,
            style: getStyleWindow("params"),
            hiddenButton: true,
            onClose: () => {
              subData.props?.input?.current?.focus();
              resumeRequest(RequestID, subData, {});
            },
          },
        );
        break;

      case "ExecuteModalDialog":
        if (json.Params.CLSID === ViewClass.Forms) {
          let height, width, setFormData;

          function setForm(data) {
            setFormData = data;
          }

          function GetFormFunction() {
            return setFormData;
          }
          const path = json.jsonData.Form.Path;
          let formsContent = json.jsonData;
          height = (parseInt(GetParams(json.jsonData.Form, "Height")) + 111).toString();
          width = (parseInt(GetParams(json.jsonData.Form, "Width")) * 1.05).toString();
          if (json.jsonData.Form.Height === undefined) {
            height = GetParams(json.jsonData, "Height");
            width = GetParams(json.jsonData, "Width");
          }
          height = Number(height) > window.innerHeight ? window.innerHeight : height;

          const onSelect = async (val: string) => {
            const json = await resumeRequest(RequestID, subData, { Result: val });
            tokenProcessingTest(json, subData);
          };

          smetaModals.open(
            <FormsMainFile
              id={subData.propsId || subData.idModal || subData.id}
              SubDataProcessing={json.jsonData.Form.Height === undefined}
              jsonFormData={formsContent}
              setForm={setForm}
              closeQuery={(data) => {
                resumeRequest(RequestID, subData, { Result: data.Result });
              }}
              path={path}
            />,
            {
              id: path,
              hiddenButton: !json.Params.Buttons && true,
              Title: json.Params.Caption,
              style: { height: `${height}px`, width: `${width}px` },
              onSelect: onSelect,
              onClose: onSelect,
              Buttons: json,
              callBacks: true,
              // closingQuery: closingQuery,
            },
          );
        } else {
          let excProps = { Token: "ExecuteModalDialog" };
          if (json.jsonData) excProps = { ...excProps, ...json.jsonData };
          if (json.Params) excProps = { ...excProps, ...json.Params };
          if (excProps.CLSID === "{010C6A4E-4954-4380-9E9F-40712B45D0DE}") excProps.Module = Prefixes.acctools;
          smetaModals.open(
            <HandleTable
              json={excProps}
              subData={{
                props: {
                  ...excProps,
                  SectionID: getModalSectionID(),
                  func: subData.func,
                  from: subData.from,
                  // htmlInput: json.jsonData.content,
                  // caption: json.Params.Caption,
                  // RequestID: json.Params.RequestID,
                },
              }}
            />,
            {
              Title: json.Params.Caption,
              style: getStyleWindow(json.Params.CLSID),
              onClose: () => {
                subData.props?.input?.current?.focus();
                resumeRequest(RequestID, subData, {});
              },
              callBacks: true,
            },
          );
        }
        break;

      case "ExposeDocument":
        exposeDocument({ json, subData, requestID: RequestID });
        break;
      case "EditDocumentField":
        editDocumentField({ json, subData, requestID: RequestID });
        break;

      case "ShellExecute":
        shellExecute(json, subData, RequestID);
        break;

      case "SelectListIndex":
        if (!json || !json.Params) break;
        const matches = json.Params.Items?.match(/[а-я\s\d\-\_\\\.\*\+\?\^\$\{\}\(\)\<\>\|\[\]\№\#]+/gi);
        if (!matches) break;
        const items = matches.map((item: string, index: number) => {
          return { text: item.replaceAll('"', ""), id: index, padding: item.match(/[\s]{6}/) ? "40px" : "" };
        });
        const onCloseSelectListIndex = () => {
          subData.props?.input?.current?.focus();
          resumeRequest(json.Params.RequestID, { target: { value: "2" } }, undefined);
        };
        smetaModals.open(
          <DialogSetObjText list={items} RequestID={json.Params.RequestID} func={subData.func} from={from} />,
          {
            Title: json.Params.Caption,
            style: getStyleWindow(),
            blockMaximize: true,
            onClose: onCloseSelectListIndex,
          },
        );
        break;

      case "GetDirectory":
        resumeRequest(RequestID, subData);
        break;

      case "OutPutText":
        outPutShow(json.Params.Text ?? "");
        // OutPutInput.value += json.Params.Text + "\n";
        resumeRequest(RequestID, subData);
        break;

      case "ClearOutPut": {
        outPutShow();
        resumeRequest(RequestID, subData);
        break;
      }

      case "PutFileStream":
        resumeRequest(RequestID, { ...subData, RCDATA: json.RCDATA });
        break;

      case "GetCertificateList":
        // if (!CheckWorkSpace()) return;
        // window.addEventListener("message", handleMessageList, false);
        // (subData.propsId)
        funcGlobal = subData.func;
        executeCertList(RequestID)
          .then((value) => {
            handleMessageList(value, subData, RequestID);
          })
          .catch((error) => {
            // console.log(error);
            const errorResumeRequest = () => {
              resumeRequest(RequestID, subData, {
                Error: "1",
                $content: error || "Ошибка получения списка сертификатов",
              });
            };
            if (!CheckWorkSpace(errorResumeRequest)) return;
            renderMessageBox({
              dlgType: 1,
              buttons: 1,
              message: error || "Ошибка получения списка сертификатов",
              closeF: errorResumeRequest,
              selectF: errorResumeRequest,
            });
          });
        break;

      case "ClientSignStream":
        // if (!CheckWorkSpace()) return;
        // window.addEventListener("message", handleMessageSign, false);
        // (subData.propsId)
        funcGlobal = subData.func;
        executeDetachedTest(json.Params.Serial, json.RCDATA)
          .then((value) => {
            handleMessageSign(value, RequestID, subData);
          })
          .catch((error) => {
            const errorResumeRequest = () => {
              resumeRequest(RequestID, subData, { Error: "1", $content: error });
            };
            if (!CheckWorkSpace(errorResumeRequest)) return;
            renderMessageBox({
              dlgType: 1,
              buttons: 1,
              message: error,
              closeF: errorResumeRequest,
              selectF: errorResumeRequest,
            });
          });
        break;

      case "cryptox509_loadbyserialnumber": {
        loadBySerialNumber(json, subData);
        break;
      }

      case "SignDialog":
        smetaModals.open(<SignDialog content={json.content} {...json.Params} subData={subData} />, {
          Title: "Подпись",
          blockMaximize: true,
          blockResize: true,
          style: getStyleWindow(),
          hiddenButton: true,
          onClose: () => {
            InputButton({ target: { value: "2" } }, RequestID, subData.func, from);
          },
        });
        break;

      case "ClientValidateStream":
        const messageContent = "Валидация подписи не удалась.";
        const errorResumeRequest = () => {
          resumeRequest(RequestID, subData, { Error: "1", $content: messageContent });
        };
        if (!CheckWorkSpace(errorResumeRequest)) return;
        webkcrypt_invoke(
          "webkcrypt-pkcs7-verify",
          {
            pkcs7: {
              value: json.RCDATA,
              "image-length": json.Params.Size ? Number(json.Params.Size) : 0,
            },
          },
          (eventVerify) => {
            if (eventVerify.data?.invoke?.out?.failed !== 0) {
              renderMessageBox({
                dlgType: 1,
                message: messageContent,
              });
              return errorResumeRequest();
            }
            //todos Если ошибка то отобразить messagebox  eventVerify.data.invoke.out.value.failure
            resumeRequest(json.Params.RequestID, subData, {
              Info: eventVerify.data.invoke.out.value.hint,
            });
          },
        );
        break;

      case "ShowDataSet":
        showDataSet({ json, subData, requestID: RequestID });
        break;

      case "Navigate":
        const sideBarData = smetaStore.get(sectionListAtom);
        if (json.Params.PageID === "-2" && sideBarData[sideBarData.length - 1].ID !== "-2") {
          smetaStore.set(pushNewSectionAtom, {
            CLSID: "{D22DFDA0-DB27-4FB4-865F-B478DB85F2A4}",
            ID: "-2",
            Name: "Фоновые процессы",
          });
        }
        smetaStore.set(setSelectedSectionAtom, getSectionByID(json.Params.PageID));
        resumeRequest(RequestID, subData);
        break;

      case "ClearFormOnSection":
        updateSection(json.Params.SectionID, "");

        // setTimeout(() => {
        resumeRequest(RequestID, subData);
        // }, 1250);
        break;

      case "CommitFormOnSection":
        updateSection(json.Params.SectionID, json.Params.Section);
        setTimeout(() => {
          resumeRequest(RequestID, subData);
        }, 1250);
        break;

      case "RefreshDocument": {
        refreshDocument(json, subData);
        break;
      }
      case "CommitFormOnHead": {
        commitFormOnHead(json, subData);
        break;
      }
      case "ClearFormOnHead": {
        clearFormOnHead(json, subData);
        break;
      }
      default:
        resumeRequest(RequestID, subData);
    }
  } else {
    let docs = document.getElementById("footerProgress");
    docs.innerHTML = "";
    const footerProgressEl = document.getElementById("footerProgress")!;
    const footerProgressElRoot: Root = footerProgressEl.root || createRoot(footerProgressEl);
    footerProgressEl.root = footerProgressElRoot;
    footerProgressElRoot.render(<></>);
    //
    const Mask = document.getElementById("loadmask");
    if (Mask) {
      Mask.remove();
    }
    if (!isEmptyObject(json)) {
      if (!isEmptyObject(json.Form) || json.ViewIdent !== undefined) {
        subData.func(json);
      } else if (!isEmptyObject(json)) {
        if (subData.func) {
          subData.func(json);
          // return ReturnData
        }
      }
      // if (json.Result) subData.func(json.Result);
    } else if (subData.from === "grid" && subData.func) {
      subData.func(json);
    }
    subData.props?.input?.current?.focus();
    // }
  }
}

interface PreShowImage {
  data: TokenJson;
  rcdata: string;
  mimeType: string | false;
  subData: TokenSubData;
  fileName?: string;
}

export function showContent({ data, rcdata, mimeType, subData }: PreShowImage) {
  if (mimeType === false) return true;
  if (mimeType.includes("png") || mimeType.includes("jpg") || mimeType.includes("jpeg")) {
    const myImage = new Image();
    try {
      myImage.onload = function () {
        const orientationVertical = myImage.naturalHeight > myImage.naturalWidth;
        smetaModals.open(
          <div style={{ display: "inline-flex", width: "100%", height: "100%" }}>
            <img src={mimeType + rcdata}></img>
          </div>,
          {
            Title: "Предпросмотр картинки",
            Buttons: {
              jsonData: {
                Кнопка$Выбрать: "Скачать",
                Кнопка$Отмена: "Закрыть",
              },
              Params: { Buttons: 3 },
            },
            style: {
              width: `${orientationVertical ? window.innerHeight * 0.3 : window.innerHeight * 0.75}px`,
              height: `${window.innerHeight * 0.75}px`,
            },
            blockMaximize: true,
            onSelect: () => {
              downloadFile(mimeType + rcdata, data, subData);
            },
            onClose: () => {
              if (data?.Params?.RequestID) resumeRequest(data?.Params?.RequestID, subData);
            },
          },
        );
      };
      myImage.src = mimeType + rcdata;
      return false;
    } catch {
      downloadFile(mimeType + rcdata, data, subData);
      if (data?.Params?.RequestID) resumeRequest(data?.Params?.RequestID, subData);
    }
  } else {
    return true;
  }
}

function downloadFile(RCDATA, json, subData) {
  let fileNameShell = json.Params.FileName;
  fileNameShell = fileNameShell.split("\\");
  const a = document.createElement("a");
  a.href = RCDATA;
  a.download = fileNameShell.slice(-1)[0];
  a.click();
  if (json?.Params?.RequestID) resumeRequest(json?.Params?.RequestID, subData);
}
